
import { ssdpSender } from '@/api/anycubic_axios';



class SSDPClient {

    async device_notify(notifyCallback) {
        window.device_notify = (cn, model, url, last) => {
            if (last == 1) {
                console.log('搜索结束')
            } else {
                console.log('新设备:', cn, model, url)
            }
            notifyCallback(cn, model, url, last)
        };
        let response = -1
        await ssdpSender.post("device_notify", { "script": "window.device_notify" })
            .then((result) => response = result);
        return response;
    }

    async search_device(st, count, timeout) {
        let response = -1
        await ssdpSender.post("search_device", { "st": st, "count": count, "timeout": timeout }).then((result) => response = result);
        return response;
    }
}

export function createSSDPClient() {
    return new SSDPClient;
}